import Box from "@mui/material/Box";
import {Typography} from "@mui/material";

export const BadgeBox = ({children, sx}) => {
  return <Box sx={{bgcolor: "rgba(0,0,0,0.35)", color: "#fff", pt: 0.2, pb: 0.6, px: 1, borderRadius: 2, ...sx, fontSize: 12}}>
    <Typography fontSize={"small"}>{children}</Typography>
  </Box>
}